












































































































































































































import store from '../../../store'
import DataTable from '../../../components/DataTable.vue'
import PageTitle from '../../../components/PageTitle.vue'
import dayjs from 'dayjs'
import { openLinkInBrowser } from '@/mla-shared'

export default {
  data () {
    return {
      name: 'Scenario 1',
      date: dayjs().format('YYYY-MM-DD'),
      spmf: [
        { id: 'st', label: 'Soil type', value: null, items: ['Loams / Sandy Loams', 'Clay Loams', 'Clay', 'Acid Sands'], display: 'select' },
        { id: 'gm', label: 'Grazing management', value: null, items: ['Intensive Rotational Grazing', 'Set Stocked or Intermittent Grazing'], display: 'select' },
        { id: 'ls', label: 'Landscape', value: null, items: ['Flat Rolling', 'Easy Hills', 'Steep Hills'], display: 'select' },
        { id: 'rf', label: 'Rainfall (mm)', value: null, items: ['600', '700', '800', '900+'], display: 'select' },
        { id: 'spmf', label: 'P Maint. Factor (Kg P/DSE)', value: 0.0, items: null, display: null }
      ],
      theaders: [
        { text: 'Field', value: 'label' },
        { text: 'Value', value: 'data.value' },
        { text: 'Calculations & comments', value: 'notes.message' }
      ],
      calculator: {
        stockingRate: 0,
        currentSoilP: 0,
        targetSoilP: 0,
        years: 0,
        capitalFactor: 0,
        costFertiliser: 0,
        nitrogen: 0,
        phosphorus: 0,
        potassium: 0,
        sulphur: 0,
        hectares: 0
      },
      openLinkInBrowser: openLinkInBrowser
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    const stored = store.state.otherTools2
    if (stored !== null) {
      this.name = stored.name
      this.date = stored.date
      this.spmf = stored.spmf
      this.calculator = stored.calculator
      this.theaders = stored.theaders
      this.tdata = stored.tdata
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateOtherTools2', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateOtherTools2', this.$data)
  },

  computed: {
    tdata: {
      get: function (this:any) {
        let maintenanceP = parseFloat(this.spmf[4].value) * parseFloat(this.calculator.stockingRate)
        let increaseInPRequired = (this.calculator.years > 0 ? (parseFloat(this.calculator.targetSoilP) - parseFloat(this.calculator.currentSoilP)) / parseFloat(this.calculator.years) : 0) || 0
        let totalPRequired = parseFloat(this.calculator.capitalFactor) * increaseInPRequired + maintenanceP
        let annualCost = (this.calculator.costFertiliser * (100 / parseFloat(this.calculator.phosphorus)) * totalPRequired) / 1000 || 0
        let totalAnnualCost = annualCost * this.calculator.hectares || 0

        let tdataArr:any[] = [
          {
            code: 'stockingRate',
            label: 'Stocking rate',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.stockingRate,
              suffix: 'DSE/ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'maintenanceP',
            label: 'Maintenance P requirement',
            data: {
              display: 'text',
              type: 'number',
              value: maintenanceP,
              suffix: 'kg/ha'
            },
            notes: {
              message: 'Calculate P maintenance factor above.',
              link: null
            },
            hidden: false
          },
          {
            code: 'currentSoilP',
            label: 'Current soil test P',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.currentSoilP,
              suffix: 'kg/ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'targetSoilP',
            label: 'Target soil test P',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.targetSoilP,
              suffix: 'kg/ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'years',
            label: 'Number of years to reach target',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.years,
              suffix: 'years'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'increaseInPRequired',
            label: 'Increase in soil test P required per year',
            data: {
              display: 'text',
              type: 'number',
              value: increaseInPRequired
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'capitalFactor',
            label: 'Capital factor',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.capitalFactor,
              suffix: 'kg P/Ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'capitalRequired',
            label: 'Capital required per year',
            data: {
              display: 'text',
              type: 'number',
              value: parseFloat(this.calculator.capitalFactor) * increaseInPRequired,
              suffix: 'kg/ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'totalPRequired',
            label: 'Total P required per year',
            data: {
              display: 'text',
              type: 'number',
              value: totalPRequired,
              suffix: 'kg/ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'costFertiliser',
            label: 'Cost of fertiliser',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.costFertiliser,
              prefix: '$',
              suffix: '/tonne'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'nitrogen',
            label: '% Nitrogen (N)',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.nitrogen,
              suffix: '%'
            },
            notes: {
              message: 'Single Super: 0% | Double Super: 0% | Super Potash 5:1: 0% | Super Potash 2:1: 0% | Super Potash 1:1: 0% | MAP: 10% | DAP: 18%',
              link: null
            },
            hidden: false
          },
          {
            code: 'phosphorus',
            label: '% Phosphorus (P)',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.phosphorus,
              suffix: '%'
            },
            notes: {
              message: 'Single Super: 8.8% | Double Super: 17.1% | Super Potash 5:1: 7.6% | Super Potash 2:1: 5.9% | Super Potash 1:1: 4.4% | MAP: 21.9% | DAP: 20%',
              link: null
            },
            hidden: false
          },
          {
            code: 'potassium',
            label: '% Potassium (K)',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.potassium,
              suffix: '%'
            },
            notes: {
              message: 'Single Super: 0% | Double Super: 0% | Super Potash 5:1: 8% | Super Potash 2:1: 16.7% | Super Potash 1:1: 25% | MAP: 0% | DAP: 0%',
              link: null
            },
            hidden: false
          },
          {
            code: 'sulphur',
            label: '% Sulphur (S)',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.sulphur,
              suffix: '%'
            },
            notes: {
              message: 'Single Super: 11% | Double Super: 4% | Super Potash 5:1: 9.2% | Super Potash 2:1: 7.3% | Super Potash 1:1: 5.5% | MAP: 1.5% | DAP: 1.6%',
              link: null
            },
            hidden: false
          },
          {
            code: 'productRequired',
            label: 'Kg product required per year (kg/ha)',
            data: {
              display: 'text',
              type: 'number',
              value: (100 / parseFloat(this.calculator.phosphorus)) * totalPRequired || 0
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'annualCost',
            label: 'Annual cost ($/ha)',
            data: {
              display: 'text',
              type: 'number',
              value: annualCost
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'hectares',
            label: 'Number of hectares',
            data: {
              display: 'input',
              type: 'number',
              value: this.calculator.hectares,
              suffix: 'ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'totalAnnualCost',
            label: 'Total annual cost ($/ha)',
            data: {
              display: 'text',
              type: 'number',
              value: totalAnnualCost
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            code: 'totalCapital',
            label: 'Total capital and maintenance cost for all years',
            data: {
              display: 'text',
              type: 'number',
              value: totalAnnualCost * this.calculator.years || 0
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          }
        ]
        return tdataArr
      },
      set: function (this:any, newValue:any) {
        let calculator = newValue
        if (calculator) {
          calculator.filter((e:any) => { this.calculator[e.code] = e.data.value })
        }
      }
    }
  },

  methods: {
    // Get the soil phosphorus Maintenance Factor
    getSPMF: function (this:any) {
      let soilLossFactor = ''
      let landscapeLossFactor = ''
      let grazingManagement = this.spmf.filter((data:any) => data.id === 'gm')[0].value
      let rainfall = this.spmf.filter((data:any) => data.id === 'rf')[0].value
      let spmf = this.spmf.filter((data:any) => data.id === 'spmf')[0].value

      this.spmf.map((data:any) => {
        // 1. Identify soil loss factor
        if (data.id === 'st') {
          switch (data.value) {
            case 'Loams/ Sandy Loams': soilLossFactor = 'low'; break
            case 'Clay Loams': soilLossFactor = 'medium'; break
            case 'Clay': soilLossFactor = 'high'; break
            case 'Acid Sands': soilLossFactor = 'high'; break
            default: break
          }
        }

        // 2. Identify landscape loss factor
        if (data.id === 'ls') {
          if (grazingManagement === 'Intensive Rotational Grazing') {
            switch (data.value) {
              case 'Flat Rolling': landscapeLossFactor = 'very low'; break
              case 'Easy Hills': landscapeLossFactor = 'low'; break
              case 'Steep Hills': landscapeLossFactor = 'medium'; break
              default: break
            }
          } else if (grazingManagement === 'Set Stocked or Intermittent Grazing') {
            switch (data.value) {
              case 'Flat Rolling': landscapeLossFactor = 'low'; break
              case 'Easy Hills': landscapeLossFactor = 'medium'; break
              case 'Steep Hills': landscapeLossFactor = 'high'; break
              default: break
            }
          }
        }
      })

      // 3. Maintenance loss factor accounting for the soil loss factor, animal/landscape loss factor and rainfall
      switch (soilLossFactor) {
        case 'low':
          switch (landscapeLossFactor) {
            case 'very low':
              switch (rainfall) { case '600': spmf = 0.48; break; case '700': spmf = 0.52; break; case '800': spmf = 0.54; break; case '900+': spmf = 0.56; break }
              break
            case 'low':
              switch (rainfall) { case '600': spmf = 0.62; break; case '700': spmf = 0.66; break; case '800': spmf = 0.68; break; case '900+': spmf = 0.72; break }
              break
            case 'medium':
              switch (rainfall) { case '600': spmf = 0.76; break; case '700': spmf = 0.80; break; case '800': spmf = 0.84; break; case '900+': spmf = 0.88; break }
              break
            case 'high':
              switch (rainfall) { case '600': spmf = 0.90; break; case '700': spmf = 0.94; break; case '800': spmf = 1.00; break; case '900+': spmf = 1.04; break }
              break
          }
          break
        case 'medium':
          switch (landscapeLossFactor) {
            case 'very low':
              switch (rainfall) { case '600': spmf = 0.72; break; case '700': spmf = 0.74; break; case '800': spmf = 0.78; break; case '900+': spmf = 0.82; break }
              break
            case 'low':
              switch (rainfall) { case '600': spmf = 0.84; break; case '700': spmf = 0.88; break; case '800': spmf = 0.92; break; case '900+': spmf = 0.98; break }
              break
            case 'medium':
              switch (rainfall) { case '600': spmf = 0.98; break; case '700': spmf = 1.04; break; case '800': spmf = 1.08; break; case '900+': spmf = 1.14; break }
              break
            case 'high':
              switch (rainfall) { case '600': spmf = 1.12; break; case '700': spmf = 1.18; break; case '800': spmf = 1.24; break; case '900+': spmf = 1.28; break }
              break
          }
          break
        case 'high':
          switch (landscapeLossFactor) {
            case 'very low':
              switch (rainfall) { case '600': spmf = 0.94; break; case '700': spmf = 0.98; break; case '800': spmf = 1.02; break; case '900+': spmf = 1.06; break }
              break
            case 'low':
              switch (rainfall) { case '600': spmf = 1.06; break; case '700': spmf = 1.12; break; case '800': spmf = 1.18; break; case '900+': spmf = 1.22; break }
              break
            case 'medium':
              switch (rainfall) { case '600': spmf = 1.20; break; case '700': spmf = 1.26; break; case '800': spmf = 1.32; break; case '900+': spmf = 1.38; break }
              break
            case 'high':
              switch (rainfall) { case '600': spmf = 1.34; break; case '700': spmf = 1.40; break; case '800': spmf = 1.48; break; case '900+': spmf = 1.54; break }
              break
          }
          break
        default:
          break
      }
      this.spmf[4].value = spmf
    },

    // Update the tdata with new values
    update: function (this:any, row:any) {
      let updatedtData = this.tdata
      let oldRow = updatedtData.filter((e:any) => e.code === row.code)
      updatedtData[this.tdata.indexOf(oldRow[0])] = row
      this.tdata = updatedtData
    },

    // Load scenario data
    loadScenario: function (this:any, item:any) {
      this.tdata = item.data1
      this.spmf = item.data2
    }
  },

  components: {
    DataTable, PageTitle
  },

  store
}
